// import React, { lazy, Suspense } from "react";
// import { Routes, Route, Navigate } from "react-router-dom";
// import { Index } from "./index";

// // import Login from "./Login/login";

// const Login = lazy(() => import("./Login/login"));

// export const Layout = () => {
//   return (
//     <div>
//       <main>
//         <Suspense
//           fallback={
//             <div className="loader-container">
//               <div className="loader"></div>
//             </div>
//           }
//         >
//           <Routes>
//             <Route path="/" element={<Login />} />
//             <Route path="/dashboard" element={<Index />} />

//             <Route path="*" element={<Navigate to="/dashboard" replace />} />
//           </Routes>
//         </Suspense>
//       </main>
//     </div>
//   );
// };




import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Topbar } from "../Components/TopBar";
import { Sidebar } from "../Components/SideBar";
import { Dashboard } from "./dashboard";


import Preloader from "../Components/Preloader";
import Login from "./Login/login";
import { UserProfile } from "./userProfile";
import { Matchmakers } from "./matchmakers";
import { Beauticians } from "./beautician";
import { Photographers } from "./photographer";
import { EventManager } from "./eventManage";
import { AddProfile } from "./useraddProfile/addProfile";
import { MatchmakerAddProfile } from "./matchmakerAddprofle/matchmakerAdd";
import { MatchEditProfile } from "./matchmakerEditprofile/matchEditProfile";
import { BeauticianAdd } from "./beauticianAddprofile/beauticianAdd";
import { BeauticianEditProfile } from "./beauticianEditprofile/beauticianEditProfile";
import { PhotographerAdd } from "./photographerAddprofile/photographerAdd";
import { PhotographerEditProfile } from "./photographerEditProfile/photographerEditProfile";
import { EventManageAdd } from "./eventManageAddprofile/eventManageAddprofile";
import { EventEditProfile } from "./eventManagerEditprofile/eventManagerEditProfile";
import { UserprofileEdit } from "./userprofileEdit/userprofileEdit";
import { MatchProfileUpload } from "./matchmakerProfleUpload/matchProfileupload";
import { Navigate } from "react-router-dom";
import { ViewProfile } from "./matchmakerProfleUpload/ViewProfile";
import { UploadUserAdd, UserAddProfile } from "./matchmakerUserAdd";
import { UploadUserEdit } from "./matchmakerUserEdit";
import { ViewMatchmakerDetails } from "./ViewMatchmakerDetails";
import { MatchmakerPlans } from "./matchmakerPlans/matchmakerPlans";
import { PaymentSuccess } from "./matchmakerPlans/PaymentSuccess";
import { PaymentFailed } from "./matchmakerPlans/PaymentFailed";
import { ContactUs } from "./matchmakerPlans/ContactUs";








export const Layout = () => {
  const location = useLocation();
  const isAuthRoute = ["/"].includes(location.pathname);

  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 992);
   const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      const timer = setTimeout(() => setLoading(false), 1000);
      return () => clearTimeout(timer);
    }, []);
    
     useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

    if (loading) {
    return <Preloader />;
  }

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

 
// const token = localStorage.getItem("token");
const token = sessionStorage.getItem("token");
if (!isAuthRoute && !token) {
  return <Navigate to="/" replace />;
}
  return (
    <div className="allRoutes">
      {isAuthRoute ? (
        <main>
         
            <Routes>
              <Route path="/" element={<Login/>} />
            
            </Routes>
       
        </main>
      ) : (
        <div style={{ display: "flex"}}>
          <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
          
           <div style={{ flex: 1, marginLeft: window.innerWidth >= 992 ? "250px" : "0", transition: "margin 0.3s",width:"100%",overflow:"auto"}} >
          
            <Topbar toggleSidebar={toggleSidebar} />
             <main style={{  minHeight: "100vh", overflowX: "auto",padding:'20px' }}>
             
                <Routes>
                 
                  <Route path="/dashboard" element={<Dashboard/>} />
                  <Route path="/user-profiles" element={<UserProfile/>}/>
                  <Route path="/add-user-profile" element={<AddProfile/>}/>
                  {/* user profile edit for matchmaker uploaded profiles  */}
                  <Route path="/userprofile-edit" element={<UserprofileEdit/>}/>
                  {/* <Route path="/userprofile-edit/:userId" element={<UserprofileEdit/>}/> */}
                  <Route path="/matchmakers" element={<Matchmakers/>}/>
                  <Route path="/view-matchmaker-details" element={<ViewMatchmakerDetails/>}/>
                  <Route path="/matchmaker-plans" element={<MatchmakerPlans/>}/>
                  <Route path="/matchmaker-add-profile" element={<MatchmakerAddProfile/>}/>
                  <Route path="/matchmaker-edit" element={<MatchEditProfile/>}/>
                  <Route path="/matchmaker-profiles-uploaded" element={<MatchProfileUpload/>}/>
                  <Route path="/matchmaker-user-add" element={<UploadUserAdd/>}/>
                  <Route path="/matchmaker-user-edit/:id" element={<UploadUserEdit/>}/>
                  <Route path="/view-profile" element={<ViewProfile/>}/>
                  <Route path="/payment-success" element={<PaymentSuccess/>}/>
                  <Route path="/payment-failed" element={<PaymentFailed/>}/>
                  <Route path="/contact-us" element={<ContactUs/>}/>


                  <Route path="/beauticians" element={<Beauticians/>}/>
                  <Route path="/beautician-add-profile" element={<BeauticianAdd/>}/>
                  <Route path="/beautician-edit" element={<BeauticianEditProfile/>}/>
                  <Route path="/photographers" element={<Photographers/>}/>
                  <Route path="/photographer-add-profile" element={<PhotographerAdd/>}/>
                  <Route path="/photographer-edit" element={<PhotographerEditProfile/>}/>
                  <Route path="/event-manager" element={<EventManager/>}/>
                  <Route path="/event-manager-add" element={<EventManageAdd/>}/>
                  <Route path="/eventmanager-edit" element={<EventEditProfile/>}/>
                  
                  
                 
                </Routes>
             
            </main>
          </div>
        </div>
      )}
    </div>
  );
};
